import { IonBreadcrumbs, IonBreadcrumb, IonIcon, IonCard, IonCardTitle, IonCardHeader, IonButton, IonCardContent, IonInput, IonModal, IonTextarea, IonProgressBar, IonLabel, IonSegmentButton, IonSegment, IonGrid, IonCol, IonRow, IonSpinner, IonSelect, IonSelectOption } from '@ionic/react';
import AppContainer from '../AppContainer';
import { chatbubbleEllipses, desktop, rocket, settingsOutline } from 'ionicons/icons';
import Menu from '../components/Menu';
import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';
import { useContext, useEffect, useState } from 'react';
import GlobalContext from '../domain/GlobalContext';
import { api } from '../domain/ApiService';
import { Assistant, Folder, Initiative, KnowledgeBaseItem, Prompt } from '../domain/Types';
import KnowledgeBase from '../components/KnowledgeBase';
import { appConfig } from '../domain/Config';
import Prompts from '../components/Prompts';
import Image from '../components/Image';
import React from 'react';
import ArtifactEditor from '../components/ArtifactEditor';

const Page: React.FC = () => {

  const { initiative, setInitiative, setInitiatives, getInitiative } = useContext(GlobalContext);
  const [ isFetched, setIsFetched ] = useState(false);
  const [ showAssistantModal, setShowAssistantModal ] = useState(false);
  const [ folder, setFolder ] = useState<Folder | null>(null);
  const [ assistant, setAssistant ] = useState<Assistant | null>(null);
  const [ artifactType, setArtifactType ] = useState<number>(0);
  const [ artifactParameters, setArtifactParameters ] = useState<any>(null);
  const [ templateAssistant, setTemplateAssistant ] = useState<Assistant | null>(null);
  const location = useLocation();
  const history = useHistory();
  const pathSegments = location.pathname.split('/').filter(Boolean);

  let folder_slug = "";
  let assistant_slug = "";
  let settings_slug = false;

  if (pathSegments.length === 2)  {
    
    assistant_slug = pathSegments[1];
  } 
  else if(pathSegments[2] === "settings") {

    assistant_slug = pathSegments[1];
    settings_slug = true;
  }
  else {

    folder_slug = pathSegments[1];
    assistant_slug = pathSegments[2];
  }

  useEffect(() => {

    setIsFetched(true);

    if (initiative != null) {

      let template = null;
      if (initiative.template_uid != null)
        template = getInitiative(initiative.template_uid);

      let assistants = initiative.assistants;
      let templateAssistants = null;
      
      if (template != null)
        templateAssistants = template.assistants;

      if (initiative.folders != null) {

        let fConfig = initiative.folders.find((f: Folder) => f.slug === folder_slug);
        let tfConfig = null;

        if (template != null && template.folders != null)
          tfConfig = template.folders.find((f: Folder) => f.slug === folder_slug);

        if (fConfig) {

          setFolder(fConfig);
          if (fConfig != null && fConfig.assistants != null)
            assistants = fConfig.assistants;
          if (tfConfig != null && tfConfig.assistants != null)
            templateAssistants = tfConfig.assistants;
        }
      }

      if (assistants != null) {

        let config = assistants.find((c: Assistant) => c.slug === assistant_slug)
        if (config != null) {

          setAssistant(config);
          setArtifactType(config.artifact_type ? config.artifact_type : 0);

          // if (config.image == null)
          //   generateImage();
        }
      }

      if (templateAssistants != null) {

        let config = templateAssistants.find((c: Assistant) => c.slug === assistant_slug)
        if (config != null)
          setTemplateAssistant(config);
      }
    }

  }, [initiative, folder_slug, assistant_slug, settings_slug, getInitiative]);

  const updateInitiative = async () => {

    if (initiative != null) {

      try { 

        await api("/initiative/update", initiative, initiative) as Initiative; 
        window.dispatchEvent(new Event('initiativeUpdated'));
      }
      catch (err) { console.error('Error:', err); }
    }
  }

  const updateAssistant = async () => {

    if ((!initiative?.assistants && !folder?.assistants) || !assistant) return;

    setIsFetched(false);

    let config = undefined;
    if (initiative?.assistants)
      config = initiative.assistants.find((c: Assistant) => c.slug === assistant_slug)
    else if (folder?.assistants)
      config = folder.assistants.find((c: Assistant) => c.slug === assistant_slug)

    if (config) {

      config.name = assistant.name;
      config.instructions = assistant.instructions;
      config.artifact_type = artifactType;
      config.artifact_description = assistant.artifact_description;

      if (artifactType == 1) {

        config.artifact_parameters = JSON.stringify({
          "type": "object",
          "properties": {
            "markdown_content": {
              "type": "string",
              "description": config.artifact_description
            }
          },
          "required": [
            "markdown_content"
          ]
        });
      } 
      else if (assistant && assistant?.artifact_parameters) {
        config.artifact_parameters = assistant.artifact_parameters;
      } 
      else {
        config.artifact_parameters = JSON.stringify({});
      }
      config.functions = assistant.functions;
      await updateInitiative();
    }
    setShowAssistantModal(false);    
    setIsFetched(true);
  };

  const navigateToParent = () => {
    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    pathSegments.pop();
    const parentPath = `/${pathSegments.join('/')}`;
    history.push(parentPath);
  };

  const removeAssistant = async () => {

    setIsFetched(false);  

    if (initiative == null) { setIsFetched(true); return; }

    if (initiative?.folders !== null && folder) {

      const iFolder = initiative?.folders?.find(f => f.id === folder.id); 

      if (!iFolder) {

        setIsFetched(true);
        return;
      }
  
      if (!iFolder.assistants)
        iFolder.assistants = [];
      
      iFolder.assistants = iFolder.assistants.filter(item => item.uid !== assistant?.uid);
    }
    else {

      initiative.assistants = initiative.assistants?.filter(item => item.uid !== assistant?.uid);      
    }

    await updateInitiative();
    setShowAssistantModal(false);
    setAssistant(null);
    setIsFetched(true);
    navigateToParent();
  };
  
  const saveKnowledgeBase = (items: KnowledgeBaseItem[]) => {

    if (assistant != null) {

      setIsFetched(false);
      assistant.knowledge_base = items;
      updateInitiative();
      setIsFetched(true);
    }
  };

  const [selectedTab, setSelectedTab] = useState<string>('default');

  function setExampleFunction(): void {
    
    if (assistant != null) {

      const updatedFunctions = JSON.stringify({
        "openapi": "3.1.0",
        "info": {
          "title": "Get weather data",
          "description": "Retrieves current weather data for a location.",
          "version": "v1.0.0"
        },
        "servers": [
          {
            "url": "https://weather.example.com"
          }
        ],
        "paths": {
          "/location": {
            "get": {
              "description": "Get temperature for a specific location",
              "operationId": "GetCurrentWeather",
              "parameters": [
                {
                  "name": "location",
                  "in": "query",
                  "description": "The city and state to retrieve the weather for",
                  "required": true,
                  "schema": {
                    "type": "string"
                  }
                }
              ],
              "deprecated": false
            }
          }
        },
        "components": {
          "schemas": {}
        }
      }, null, 2);

      setAssistant(prev => prev ? { ...prev, functions: updatedFunctions } : prev);
    }
  }

  function formatJSON(value: string | undefined): string {
    if (!value) return "{}";
    try {
      return JSON.stringify(JSON.parse(value), null, 4);
    } catch (err) {
      return "{}";
    }
  }

  function parseJSON(value: string | undefined): any {
    if (!value) return null;
    try {
      return JSON.parse(value);
    } catch (err) {
      return value;
    }
  }

  function setExampleArtifact(): void {
    
    if (assistant != null) {

      const updatedArtifactParameters = JSON.stringify({
        "type": "object",
        "properties": {
          "benefit": {
            "type": "string",
            "description": "The benefit of the product"
          },
          "category": {
            "type": "string",
            "description": "The category of the product"
          }
        },
        "required": [
          "benefit"
        ]
      }, null, 2);

      setAssistant(prev => prev ? { ...prev, artifact_parameters: updatedArtifactParameters } : prev);
    }
  }

  const [imageLoading, setImageLoading] = useState(false);
  const generateImage = async () => {
    if (assistant == null) return;
    setImageLoading(true);
    assistant.image = undefined;
    let image = await api(
      "/assistant/image",
      { assistant_uid: assistant.uid, image_prompt: assistant?.instructions },
      initiative
    );
    assistant.image = image;
    setAssistant({ ...assistant });

    if (initiative != null) {

      const response = await api("/initiative/list", {}, initiative);
      setInitiatives(response);
      setInitiative({ ...initiative });
    }

    window.dispatchEvent(new Event('initiativesLoaded'));      
    window.dispatchEvent(new Event('initiativeUpdated'));

    setImageLoading(false);
  };  

  const handleSave = (updatedConfig: any) => {
    if(assistant) {

        assistant.artifact_parameters = JSON.stringify(updatedConfig);
        setArtifactParameters(assistant.artifact_parameters)
        updateAssistant();
      }
    };

  return (
    <>
      {(isFetched && initiative != null && initiative.initiative_type != null) ? (
      <>
      <IonCard className='filled' style={{ padding: "10px" }}>
      <IonGrid style={{width: "100%"}}>
        <IonRow style={{width: "100%"}}>
          <IonCol size="3">
            <div style={{margin: "30px", marginTop: "10px", width: "70%"}}>
            <Image
                src={assistant?.image}
                width="100%"
                isLoading={imageLoading}
                profile={true}
              />
            </div>
          </IonCol>
          <IonCol size="9">
            <div style={{margin: "10px"}}>
             <div style={{ position: "relative", left: "-5px", marginBottom: "15px"}}>
             <IonButton className='basic' onClick={() => { setShowAssistantModal(true); }}>Modify</IonButton>
              <IonButton className='basic'
                disabled={imageLoading}
                style={{ width: '180px' }} // Fixed width for the button
                onClick={() => { generateImage(); }}
              >
                {imageLoading ? (
                  <IonSpinner
                    name="dots"
                    color="dark"
                    style={{ width: '16px', height: '16px' }} // Inline style for spinner size
                  />
                ) : (
                  <>Generate new profile</>
                )}
              </IonButton>     
              </div>       
              <IonCardTitle>{assistant?.name}</IonCardTitle>
              <div style={{ lineHeight: "1.5", paddingTop: "10px", paddingBottom: "10px" }}>
                <span style={{opacity: "0.6"}}>Delivers:</span> {assistant?.artifact_description}
              </div>
              <div style={{ lineHeight: "1.5", paddingTop: "10px", paddingBottom: "10px" }}>
                <span style={{opacity: "0.6"}}>Instructions:</span> 
                <span style={{display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 10, // Limits to 10 lines
                              overflow: "hidden",
                              textOverflow: "ellipsis",}}>{assistant?.instructions}</span>
              </div>
              </div>
          </IonCol>
          </IonRow>
        </IonGrid>
      </IonCard>

      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Artifacts</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>

          <>

            <IonSelect
              label="Artifact Type"
              placeholder="Select type"
              labelPlacement="floating"
              interface="popover"
              value={artifactType}
              onIonChange={(e) => setArtifactType(e.detail.value)}
            >
              <IonSelectOption value={0}>No Artifact</IonSelectOption>
              <IonSelectOption value={1}>Markdown Artifact</IonSelectOption>
              <IonSelectOption value={2}>Structured Artifacts</IonSelectOption>
            </IonSelect>

            <div className="form-textarea-container" style={artifactType !== 0 ? { display: 'block' } : {  display: 'none' }}>
            <IonTextarea
              className='form-element'
              label="Artifact description"
              labelPlacement="floating"
              fill="outline"
              rows={2}
              value={assistant?.artifact_description}
              onIonChange={e => setAssistant(prev => prev ? { ...prev, artifact_description: e.detail.value! } : prev)}
              placeholder="Artifact description"
              disabled={artifactType === 0}
              hidden={artifactType === 0}
            />
            </div>

            <div className="form-textarea-container" style={artifactType !== 2 ? { display: 'none' } : {  display: 'block' }}>
            <ArtifactEditor initialConfig={assistant?.artifact_parameters ? parseJSON(assistant.artifact_parameters) : null} onSave={handleSave} />
            </div>
            {/* 
            <pre style={{ padding: '10px', borderRadius: '5px' }}>
              {formatJSON(artifactParameters)}
            </pre>
            <IonButton onClick={updateAssistant}>Save</IonButton>
            */}
          </>

        </IonCardContent>
      </IonCard>

      <KnowledgeBase 
        items={assistant?.knowledge_base != null ? assistant?.knowledge_base : []} 
        templateItems={templateAssistant?.knowledge_base != null ? templateAssistant?.knowledge_base : []} 
        assistant_uid={assistant?.uid} 
        folder_uid={folder?.uid} 
        label="Assistant knowledge base"
        onSave={saveKnowledgeBase} />

      <IonCard className='filled' style={{ padding: "10px" }}>
        <IonCardHeader>
          <IonCardTitle>Cues</IonCardTitle>
        </IonCardHeader>
        <IonCardContent>
          <Prompts assistant_uid={assistant?.uid} showHeader={true} showActions={true} />
          {templateAssistant?.uid != null ? 
          <>
            <div className='mid-header'>From template</div>
            <Prompts assistant_uid={templateAssistant?.uid} showHeader={false} showActions={false} />
          </> 
          : <></> }

        </IonCardContent>
      </IonCard>

      <IonModal className='form-modal' isOpen={showAssistantModal} onDidDismiss={() => setShowAssistantModal(false)}>
          <div className='form'>

              {/*(appConfig.initiativeTypes.length === 1 && appConfig.initiativeTypes[0] === 'client') ? 
                <></>
                : <>
                  <IonSegment onIonChange={e => setSelectedTab(e.detail.value as string)} value={selectedTab}>
                    <IonSegmentButton value="default">
                      <IonLabel>Assistant</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="artifact">
                      <IonLabel>Artifact</IonLabel>
                    </IonSegmentButton>
                    <IonSegmentButton value="functions">
                      <IonLabel>Functions</IonLabel>
                    </IonSegmentButton>
                  </IonSegment>
                </> */}
              <div style={{height: "330px", paddingTop: "10px"}}>
              {selectedTab === 'default' && (
                <div>
                  <IonInput
                    className='form-element'
                    label="Name"
                    labelPlacement="floating"
                    fill="outline"
                    value={assistant?.name} 
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, name: e.detail.value! } : prev)}
                    placeholder="Name"
                  />              
                  <IonTextarea 
                    label="Instruction"
                    className='form-element'
                    labelPlacement="floating"
                    fill="outline"
                    rows={10}            
                    value={assistant?.instructions}
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, instructions: e.detail.value! } : prev)}
                    placeholder="Instruction"
                  />
                </div>
              )}
              {selectedTab === 'artifact' && (
                  <>
                  <IonSelect
                    label="Artifact Type"
                    placeholder="Select type"
                    labelPlacement="floating"
                    interface="popover"
                    value={artifactType}
                    onIonChange={(e) => setArtifactType(e.detail.value)}
                  >
                    <IonSelectOption value={0}>No Artifact</IonSelectOption>
                    <IonSelectOption value={1}>Markdown Artifact</IonSelectOption>
                    <IonSelectOption value={2}>Structured Artifacts</IonSelectOption>
                  </IonSelect>

                  <IonTextarea
                    className='form-element'
                    label="Artifact description"
                    labelPlacement="floating"
                    fill="outline"
                    rows={2}
                    value={assistant?.artifact_description}
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, artifact_description: e.detail.value! } : prev)}
                    placeholder="Artifact description"
                    disabled={artifactType === 0}
                    hidden={artifactType === 0}
                  />

                  <div className="form-textarea-container" hidden={artifactType !== 2}>
                    <div className="form-labels-container">
                      <IonLabel color="medium">JSON checked</IonLabel>
                      <IonLabel color="primary" className="link" onClick={() => setExampleArtifact()}>
                        Use an example artifact
                      </IonLabel>
                    </div>
                    <IonTextarea
                      className='form-element form-element-json'
                      label="Artifact parameters (JSON)"
                      labelPlacement="floating"
                      fill="outline"
                      rows={9}
                      value={formatJSON(assistant?.artifact_parameters)}
                      disabled={artifactType === 0 || artifactType === 1}
                      hidden={artifactType === 0|| artifactType === 1}
                      onIonChange={e => setAssistant(prev => prev ? { ...prev, artifact_parameters: e.detail.value! } : prev)}
                      placeholder="Artifact parameters (JSON)"
                    /> 
                  </div>
                </>
              )}
              {selectedTab === 'functions' && (
                <div className="form-textarea-container">
                  <div className="form-labels-container">
                    <IonLabel color="medium">JSON checked</IonLabel>
                    <IonLabel color="primary" className="link" onClick={() => setExampleFunction()}>Use an example function</IonLabel>
                  </div>
                  <IonTextarea 
                    className='form-element form-element-json'
                    label="Functions (JSON)"
                    labelPlacement="floating"
                    fill="outline"
                    rows={20}
                    value={assistant?.functions}
                    onIonChange={e => setAssistant(prev => prev ? { ...prev, functions: e.detail.value! } : prev)}
                    placeholder="Functions (JSON)"
                  />
                </div>
              )}
              </div>
            <IonButton onClick={updateAssistant}>Save</IonButton>
            <IonButton className='basic' onClick={() => { setShowAssistantModal(false); }}>Cancel</IonButton>
            <IonButton color="danger" onClick={removeAssistant}>Remove</IonButton>

          </div>
        </IonModal>
        </>
      
      ) : (

        <IonProgressBar type="indeterminate" color="medium"></IonProgressBar>

      )}
    </>
  );
};

const Breadcrumb: React.FC = () => {
    const { initiative } = useContext(GlobalContext);
    const location = useLocation();
    const pathSegments = location.pathname.split('/').filter(Boolean);

    let assistant = null;
    let folder_slug = "";
    let assistant_slug = "";
    let settings_slug = false;

    if (pathSegments.length === 2)  {
      
      assistant_slug = pathSegments[1];
    } 
    else if(pathSegments[2] === "settings") {

      assistant_slug = pathSegments[1];
      settings_slug = true;
    }
    else {

      folder_slug = pathSegments[1];
      assistant_slug = pathSegments[2];
    }

    if (initiative?.assistants != null) {

      assistant = initiative.assistants.find((c: Assistant) => c.slug === assistant_slug)
    }

    return (
      <IonBreadcrumbs>
        <IonBreadcrumb routerLink={"/"}>
          <IonIcon slot="start" icon={rocket}></IonIcon>
          Base
        </IonBreadcrumb>
        <IonBreadcrumb routerLink={"../../"+ initiative?.slug}>
          <IonIcon slot="start" icon={desktop}></IonIcon>
          {initiative?.name}
        </IonBreadcrumb>
        <IonBreadcrumb routerLink={"../"+ assistant_slug}>
          <IonIcon slot="start" icon={chatbubbleEllipses}></IonIcon>
          {assistant?.name}
        </IonBreadcrumb>
        <IonBreadcrumb>        
          <IonIcon slot="end" icon={settingsOutline}></IonIcon>
          Settings
        </IonBreadcrumb>
      </IonBreadcrumbs>   
    );
  };
  
const Container: React.FC<{}> = () => { return <AppContainer ContentComponent={Page} BreadcrumbComponent={Breadcrumb} MenuComponent={Menu} />; };
export default Container;